import favicon from 'assets/img/themes/inroads/favicon.png';
import background from 'assets/img/themes/inroads/background.jpg';
import logo from 'assets/img/themes/inroads/logo.png';
import sidebarLogo from 'assets/img/themes/inroads/logo-sidebar.png';
import collapsed from 'assets/img/themes/inroads/logo-sidebar-collapsed.png';

export default {
  background: {
    src: background,
  },
  logo: {
    src: logo,
    height: '90px',
  },
  sidebar: {
    logo: sidebarLogo,
    collapsed: collapsed,
  },
  page: {
    title: 'InRoads Truck Rentals',
    favicon: favicon,
    support: 'InRoads Truck Rentals Support',
  },
  footer: {
    url: 'https://launchmobility.com',
    copyright: 'Launch Mobility, Inc.',
    version: true,
  },
};
